(function () {
  'use strict';

  var form = document.querySelector('.bulk-form');
  if (!form) return;

  form.addEventListener('submit', function () {
    var bodyField = form.querySelector('[data-bulk-body-field]');
    var companyField = form.querySelector('[data-bulk-company]');
    var modelField = form.querySelector('[data-bulk-model]');
    var quantityField = form.querySelector('[data-bulk-quantity]');
    var messageField = form.querySelector('[data-bulk-message]');
    if (!bodyField) return;

    var lines = [
      '--- Storköpsförfrågan ---',
      'Företag / webbplats: ' + (companyField && companyField.value ? companyField.value : '—'),
      'Produktmodell: ' + (modelField && modelField.value ? modelField.value : '—'),
      'Förväntad kvantitet: ' + (quantityField && quantityField.value ? quantityField.value : '—'),
      '---',
      messageField && messageField.value ? messageField.value : '—',
    ];

    bodyField.value = lines.join('\n');
  });
})();
